<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
const store = useStore();
const keyword = computed(() => store.getters.getKeyword);
const isInputting = computed(() => store.getters.isInputting);
const setKeyword = (value) => store.commit('setKeyword', value);
const setInputting = (value) => store.commit('setInputting', value);
const searchInput = ref(null);
const handleInput = (e) => {
  setKeyword(e.target.value);
  setInputting(true);
}
const reset = () => {
  setKeyword('');
  searchInput.value.focus();
}
const cancel = () => {
  setKeyword('');
  setInputting(false);
}
</script>

<template>
  <div :class="{'search-box': true, 'bg-not-inputting': !isInputting}">
    <input type="text" ref="searchInput" placeholder="请输入问题关键词" :class="isInputting ? 'search-input-has-value' : 'search-input-no-value'" :value="keyword" @input="handleInput"/>
    <img src="../assets/x.png" @click="reset" class="x" v-if="keyword" alt="x"/>
    <span @click="cancel" class="cancel" v-if="isInputting">取消</span>
  </div>
</template>

<style scoped lang="scss">
@import '~/entries/index/index.scss';
@mixin search {
  height: 70 * $px;
  padding-left: 70 * $px;   // 为图标留出空间
  padding-right: 70 * $px;  // 为图标留出空间
  margin-top: 10 * $px;
  margin-bottom: 10 * $px;
  border: 2 * $px solid #666666;
  border-radius: 45 * $px;
  font-size: 24 * $px;
  background-color: #fff;
  outline: none;

  &::placeholder {
    color: #bcbcbc;
  }
}

.bg-not-inputting {
  background: rgba(245, 248, 253, 1);
}
.search-box {
  position: relative;
  display: inline-block;
  margin: 24 * $px;

  .search-input-no-value {
    width: 558 * $px;
    @include search;
  }
  .search-input-has-value {
    width: 460 * $px;
    @include search;
  }
  .x {
    position: absolute;
    top: 50%;
    right: 130 * $px; // 调整图标与输入框边缘的距离
    transform: translateY(-50%); // 垂直居中
    width: 30 * $px;
    height: 30 * $px;
  }
  .cancel {
    margin-left: 25 * $px;
    font-size: 28 * $px;
    line-height: 70 * $px;
    color: rgba(75, 106, 255, 1);
  }
  &::before {
    content: '';
    position: absolute;
    left: 30 * $px;
    top: 50%;
    transform: translateY(-50%);
    width: 30 * $px;
    height: 30 * $px;
    background-image: url('../assets/search.png');
    background-size: cover;
  }
}
</style>
